import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export function Panel({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "rounded-[2rem] border border-white/70 bg-white/72 p-6 shadow-panel backdrop-blur",
        className,
      )}
      {...props}
    />
  );
}
